import { render, staticRenderFns } from "./DialogFormAssetEdit.vue?vue&type=template&id=2af540f3"
import script from "./DialogFormAssetEdit.vue?vue&type=script&lang=js"
export * from "./DialogFormAssetEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports